import { render, staticRenderFns } from "./CustomerReportTemplate.vue?vue&type=template&id=a41ce7d8"
import script from "./CustomerReportTemplate.vue?vue&type=script&lang=js"
export * from "./CustomerReportTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports